export default Object.freeze({
  InstanceName: 'instance-name',
  InstanceIdentifier: 'instance-identifier',
  InstanceDetailsViewUrl: 'instance-details-view-url',
});
